<section class="available-page">
  <div class="page-header">
    <h1>Available</h1>
  </div>

  <div class="table-panel">
    @if (loading()) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else {
      <div class="table-wrap">
        @if (sortedHandoffs().length) {
          <table class="available-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>City</th>
                <th class="time-col">
                  <button type="button" class="sort-trigger" (click)="toggleTimeSort()">
                    <span>Time</span>
                    <mat-icon aria-hidden="true">
                      {{ sortDirection() === 'desc' ? 'south' : 'north' }}
                    </mat-icon>
                  </button>
                </th>
                <th>Category</th>
                <th>Status</th>
                <th class="actions-col">Actions</th>
              </tr>
            </thead>

            <tbody>
              @for (row of sortedHandoffs(); track row.id) {
                <tr>
                  <td>
                    <div class="customer-cell">
                      <span class="customer-avatar">
                        <mat-icon aria-hidden="true">person</mat-icon>
                      </span>

                      <span class="customer-copy">
                        <span class="customer-name">{{ customerLabel(row) }}</span>
                        @if (row.customer_phone) {
                          <span class="customer-meta">{{ row.customer_phone }}</span>
                        }
                      </span>
                    </div>
                  </td>

                  <td class="city-cell">{{ row.city_code || '—' }}</td>
                  <td class="time-cell">{{ formatCreatedAt(row.created_at) }}</td>
                  <td class="category-cell">{{ row.category || '—' }}</td>

                  <td class="status-cell">
                    <span class="status-chip pending">Pending</span>
                    @if (isOverdue(row)) {
                      <span class="status-chip overdue">Overdue</span>
                    }
                  </td>

                  <td class="actions-cell">
                    <button
                      type="button"
                      class="primary-blue-btn"
                      (click)="claim(row)"
                      [disabled]="busyId() === row.id"
                    >
                      Claim
                    </button>

                    <a class="primary-teal-btn" [routerLink]="['/available', row.id]">
                      Open
                    </a>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div class="empty">No pending handoffs.</div>
        }
      </div>
    }
  </div>
</section>